import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import PropTypes from "prop-types";
import { Flex, RadioFilterButton, Fieldset } from "@base-ui";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
var styledSystemKeys = ["space", "layout", "flexbox", "border"];
var RadioFilterFieldset = function RadioFilterFieldset(props) {
  var id = props.id,
    legend = props.legend,
    hideLegend = props.hideLegend,
    options = props.options,
    updateSelected = props.updateSelected,
    name = props.name,
    icon = props.icon,
    className = props.className;
  var radioFilters = options.map(function (option) {
    return /*#__PURE__*/_jsx(RadioFilterButton, {
      id: "".concat(id, "-radio-").concat(option.id),
      label: option.label,
      name: name,
      checked: option.checked,
      active: option.checked,
      onChange: function onChange() {
        return updateSelected(option.id);
      }
    }, option.id);
  });
  return /*#__PURE__*/_jsx(Fieldset, _objectSpread(_objectSpread({
    legend: legend,
    hideLegend: hideLegend,
    className: className,
    icon: icon
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: /*#__PURE__*/_jsx(Flex.Row, {
      flexWrap: "wrap",
      width: "inherit",
      children: radioFilters
    })
  }));
};
RadioFilterFieldset.propTypes = {
  id: PropTypes.string.isRequired,
  legend: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  updateSelected: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  hideLegend: PropTypes.oneOf([true, false]),
  icon: PropTypes.string,
  className: PropTypes.string
};
export default RadioFilterFieldset;